import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './App.css';
import { AddGoogleProject, GoogleProjectActions } from './pages/GoogleProjectManager';

const API = 'https://api.eighteen-media.id';

function App() {
  const [token, setToken] = useState(localStorage.getItem('admin_token'));
  const [page, setPage] = useState('dashboard');
  const [audioList, setAudioList] = useState([]);
  const [payoutList, setPayoutList] = useState([]);
  const [payoutLoading, setPayoutLoading] = useState(false);
  const [payoutMsg, setPayoutMsg] = useState('');
  const [audioLoading, setAudioLoading] = useState(false);
  const [audioUploadForm, setAudioUploadForm] = useState({title:'',artist:'',genre:'',mood:'',source:''});
  const [audioFile, setAudioFile] = useState(null);
  const [audioUploading, setAudioUploading] = useState(false);
  const [audioMsg, setAudioMsg] = useState('');
  const [visualList, setVisualList] = useState([]);
  const [visualLoading, setVisualLoading] = useState(false);
  const [visualUploadForm, setVisualUploadForm] = useState({type:'bg',label:'',source:''});
  const [visualFile, setVisualFile] = useState(null);
  const [visualUploading, setVisualUploading] = useState(false);
  const [visualMsg, setVisualMsg] = useState('');
  const [stats, setStats] = useState(null);
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [cookieInputs, setCookieInputs] = useState({});
  const [cookieMsg, setCookieMsg] = useState('');
  const [loginForm, setLoginForm] = useState({ username: '', password: '' });
  const [loginError, setLoginError] = useState('');
  const [msg, setMsg] = useState({ text: '', type: 'success' });
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [aiStats, setAiStats] = useState(null);
  const [aiClients, setAiClients] = useState([]);
  const [clientTiktok, setClientTiktok] = useState([]);
  const [googleProjects, setGoogleProjects] = useState([]);

  const showMsg = (text, type = 'success') => {
    setMsg({ text, type });
    setTimeout(() => setMsg({ text: '', type: 'success' }), 3000);
  };

  useEffect(() => {
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      fetchStats();
      fetchClients();
      fetchGoogleProjects();
    }
  }, [token]);

  useEffect(() => {
    if (page === 'audio') fetchAudioLibrary();
    if (page === 'ugc-templates') fetchVisualTemplates();
    if (page === 'gprojects') fetchGoogleProjects();
  }, [page]);
  // Tinggi layar asli HP (address bar muncul/hilang) + kunci scroll halaman saat sidebar terbuka — 2026-10-09
  useEffect(() => {
    const setH = () => document.documentElement.style.setProperty('--app-h', `${window.innerHeight}px`);
    setH();
    window.addEventListener('resize', setH);
    window.addEventListener('orientationchange', setH);
    return () => { window.removeEventListener('resize', setH); window.removeEventListener('orientationchange', setH); };
  }, []);
  useEffect(() => {
    document.body.style.overflow = sidebarOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [sidebarOpen]);
  const fetchGoogleProjects = async () => {
    try {
      const res = await axios.get(`${API}/api/admin/google-projects`);
      setGoogleProjects(res.data || []);
    } catch (e) {
      setGoogleProjects([]);
    }
  };

  const login = async (e) => {
    e.preventDefault();
    setLoginError('');
    try {
      const res = await axios.post(`${API}/api/admin/login`, loginForm);
      localStorage.setItem('admin_token', res.data.token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`;
      setToken(res.data.token);
    } catch (err) { setLoginError(err.response?.data?.error || 'Login gagal'); }
  };

  const logout = () => { localStorage.removeItem('admin_token'); setToken(null); };

  const fetchStats = async () => {
    const r = await axios.get(`${API}/api/admin/stats`).catch(() => {});
    if (r) setStats(r.data);
    const ai = await axios.get(`${API}/api/admin/ai/credits/stats`).catch(() => {});
    if (ai) setAiStats(ai.data);
    const aic = await axios.get(`${API}/api/admin/ai/credits/clients`).catch(() => {});
    if (aic) setAiClients(aic.data);
  };

  const fetchClients = async () => {
    const r = await axios.get(`${API}/api/admin/clients`).catch(() => {});
    if (r) setClients(r.data);
  };

  const fetchClientDetail = async (id) => {
    const r = await axios.get(`${API}/api/admin/clients/${id}`).catch(() => {});
    if (r) setSelectedClient(r.data);
    const tt = await axios.get(`${API}/api/admin/clients/${id}/tiktok`).catch(() => {});
    if (tt) setClientTiktok(tt.data.accounts || []);
    setPage('client-detail');
    setSidebarOpen(false);
  };

  const setSubscription = async (clientId, plan) => {
    try {
      const r = await axios.post(`${API}/api/admin/clients/${clientId}/subscription`, { plan, days: 30 });
      showMsg(r.data.message);
      fetchClients();
      fetchClientDetail(clientId);
    } catch (err) { showMsg(err.response?.data?.error || 'Error', 'error'); }
  };

  const toggleUgcAccess = async (clientId, current) => {
    await axios.put(`${API}/api/admin/clients/${clientId}/ugc-access`, { ugc_enabled: !current });
    showMsg(!current ? '🎬 UGC diaktifkan' : '🎬 UGC dimatikan');
    fetchClients();
    fetchClientDetail(clientId);
  };
  const toggleUrlSource = async (clientId, current) => {
    try {
      await axios.put(`${API}/api/admin/clients/${clientId}/url-source`, { url_source_enabled: !current });
      showMsg(!current ? '🔗 Sumber dari URL diaktifkan' : '🔗 Sumber dari URL dimatikan — klien hanya bisa upload file');
      fetchClients();
      fetchClientDetail(clientId);
    } catch (err) { showMsg(err.response?.data?.error || 'Error', 'error'); }
  };
  const toggleStatus = async (clientId, status) => {
    const s = status === 'active' ? 'suspended' : 'active';
    await axios.patch(`${API}/api/admin/clients/${clientId}/status`, { status: s });
    showMsg(`Client ${s}`);
    fetchClients();
    fetchClientDetail(clientId);
  };

  const toggleYtEmail = async (emailId, status, clientId) => {
    const s = status === 'pending' ? 'connected' : 'pending';
    await axios.patch(`${API}/api/admin/yt-email/${emailId}`, { status: s });
    showMsg(s === 'connected' ? '✅ Connected!' : '⏳ Pending');
    fetchClientDetail(clientId);
    fetchClients();
  };

  const topupCredits = async (clientId, amount) => {
    try {
      const r = await axios.post(`${API}/api/admin/ai/credits/topup`, { client_id: clientId, amount: parseInt(amount) });
      showMsg(r.data.message);
      const aic = await axios.get(`${API}/api/admin/ai/credits/clients`).catch(() => {});
      if (aic) setAiClients(aic.data);
      fetchClientDetail(clientId);
    } catch (err) { showMsg(err.response?.data?.error || 'Error', 'error'); }
  };

  const deleteClient = async (clientId, email) => {
    if (!window.confirm(`Hapus client ${email}? Semua data akan terhapus permanen!`)) return;
    try {
      await axios.delete(`${API}/api/admin/clients/${clientId}`);
      alert('Client berhasil dihapus');
      setSelectedClient(null);
      fetchClients();
      setPage('clients');
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal hapus client');
    }
  };

  const previewInvoice = (clientId) => {
    const token = localStorage.getItem('admin_token');
    window.open(`${API}/api/invoice/preview/${clientId}?token=${token}`, '_blank');
  };

  const sendInvoice = async (clientId, email) => {
    if (!window.confirm(`Kirim invoice ke ${email}?`)) return;
    try {
      const r = await axios.post(`${API}/api/invoice/send/${clientId}`);
      alert(r.data.message);
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal kirim invoice');
    }
  };

  const updateCookie = async (channelId, clientId) => {
    const cookieData = cookieInputs[channelId];
    if (!cookieData || cookieData.trim().length < 10) {
      setCookieMsg('Cookie tidak boleh kosong!');
      setTimeout(() => setCookieMsg(''), 3000);
      return;
    }
    try {
      await axios.post(`${API}/api/admin/cookie/${channelId}/update`, { cookie_data: cookieData });
      setCookieMsg('✅ Cookie berhasil diupdate!');
      setCookieInputs(prev => ({ ...prev, [channelId]: '' }));
      setTimeout(() => setCookieMsg(''), 3000);
      fetchClientDetail(clientId);
    } catch (err) {
      setCookieMsg('❌ ' + (err.response?.data?.error || 'Gagal update cookie'));
      setTimeout(() => setCookieMsg(''), 3000);
    }
  };

  const setupPostiz = async (clientId) => {
    if (!window.confirm('Setup akun Postiz untuk Instagram client ini?')) return;
    try {
      const r = await axios.post(`${API}/api/admin/clients/${clientId}/setup-postiz`);
      alert(r.data.message + (r.data.connectUrl ? `\n\nKirim link ini ke client untuk connect Instagram:\n${r.data.connectUrl}` : ''));
      fetchClientDetail(clientId);
    } catch (e) {
      alert(e.response?.data?.error || 'Gagal setup Postiz');
    }
  };

  const resetCookie = async (channelId, clientId) => {
    if (!window.confirm('Mark cookie sebagai invalid/expired?')) return;
    try {
      await axios.patch(`${API}/api/admin/cookie/${channelId}/reset`);
      showMsg('Cookie di-reset, client perlu upload ulang');
      fetchClientDetail(clientId);
    } catch (err) { showMsg('Gagal reset cookie', 'error'); }
  };

  const addExtraLimit = async (clientId, extra) => {
    try {
      const r = await axios.post(`${API}/api/admin/clients/${clientId}/extra-limit`, { extra });
      showMsg(r.data.message);
      fetchClientDetail(clientId);
    } catch (err) { showMsg('Gagal tambah limit', 'error'); }
  };

  const updateTiktokDailyCap = async (accountId, capValue, clientId) => {
    const cap = parseInt(capValue, 10);
    if (!Number.isInteger(cap) || cap < 1 || cap > 15) {
      showMsg('Cap harus antara 1-15', 'error');
      return;
    }
    try {
      await axios.patch(`${API}/api/admin/tiktok/${accountId}/daily-cap`, { cap });
      showMsg(`Cap posting harian diubah ke ${cap}`);
      const tt = await axios.get(`${API}/api/admin/clients/${clientId}/tiktok`).catch(() => {});
      if (tt) setClientTiktok(tt.data.accounts || []);
    } catch (err) {
      showMsg(err.response?.data?.error || 'Gagal ubah cap', 'error');
    }
  };

  const deleteTiktokAccount = async (accountId, displayName, clientId) => {
    if (!window.confirm(`Hapus akun TikTok "${displayName}" permanen?`)) return;
    try {
      await axios.delete(`${API}/api/admin/tiktok/${accountId}`);
      showMsg(`Akun TikTok ${displayName} berhasil dihapus`);
      const tt = await axios.get(`${API}/api/admin/clients/${clientId}/tiktok`).catch(() => {});
      if (tt) setClientTiktok(tt.data.accounts || []);
    } catch (err) { showMsg('Gagal hapus akun TikTok', 'error'); }
  };

  if (!token) {
    return (
      <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'linear-gradient(135deg,#070b16,rgba(255,255,255,0.055))',padding:16}}>
        <div style={{width:'100%',maxWidth:360,background:'rgba(255,255,255,0.055)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:16,padding:32}}>
          <div style={{display:'flex',alignItems:'baseline',gap:4,marginBottom:20}}>
            <span style={{fontSize:26,fontWeight:800,background:'linear-gradient(135deg,#a06bff,#22d3ee)',WebkitBackgroundClip:'text',WebkitTextFillColor:'transparent'}}>18</span>
            <span style={{fontSize:10,fontWeight:600,color:'#ef4444',letterSpacing:3}}>ADMIN</span>
          </div>
          <h2 style={{color:'#f1f5f9',marginBottom:4,fontSize:20}}>Admin Panel</h2>
          <p style={{color:'#64748b',fontSize:13,marginBottom:24}}>Eighteen Media Operations</p>
          {loginError && <div style={{background:'rgba(239,68,68,0.16)',border:'1px solid #ef4444',color:'#ef4444',padding:'10px 14px',borderRadius:8,fontSize:13,marginBottom:14}}>{loginError}</div>}
          <form onSubmit={login}>
            <div style={{marginBottom:12}}>
              <label style={{display:'block',fontSize:12,color:'#94a3b8',marginBottom:5}}>Username</label>
              <input style={{width:'100%',padding:'10px 12px',background:'rgba(255,255,255,0.075)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:8,color:'#f1f5f9',fontSize:16,outline:'none',boxSizing:'border-box'}}
                type="text" value={loginForm.username} onChange={e=>setLoginForm({...loginForm,username:e.target.value})} placeholder="fzl420" required />
            </div>
            <div style={{marginBottom:20}}>
              <label style={{display:'block',fontSize:12,color:'#94a3b8',marginBottom:5}}>Password</label>
              <input style={{width:'100%',padding:'10px 12px',background:'rgba(255,255,255,0.075)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:8,color:'#f1f5f9',fontSize:16,outline:'none',boxSizing:'border-box'}}
                type="password" value={loginForm.password} onChange={e=>setLoginForm({...loginForm,password:e.target.value})} placeholder="••••••••" required />
            </div>
            <button type="submit" style={{background:'linear-gradient(135deg,#a06bff,#22d3ee)',color:'#000',padding:'12px',border:'none',borderRadius:8,fontWeight:700,fontSize:15,cursor:'pointer',width:'100%'}}>
              Login
            </button>
          </form>
        </div>
      </div>
    );
  }

  const fetchPayouts = async () => {
    setPayoutLoading(true);
    try {
      const res = await fetch(API + '/api/affiliate/admin', { headers: { Authorization: 'Bearer ' + token } });
      const data = await res.json();
      setPayoutList(Array.isArray(data) ? data : []);
    } catch(e) { setPayoutList([]); } finally { setPayoutLoading(false); }
  };

  const updatePayout = async (id, status, note) => {
    try {
      const res = await fetch(API + '/api/affiliate/admin/' + id, {
        method: 'PUT',
        headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'application/json' },
        body: JSON.stringify({ status, admin_note: note })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setPayoutMsg(status === 'paid' ? '✅ Payout ditandai DIBAYAR' : '❌ Payout DITOLAK');
      fetchPayouts();
    } catch(e) { setPayoutMsg('Error: ' + e.message); }
  };


  const fetchAudioLibrary = async () => {
    setAudioLoading(true);
    try {
      const res = await fetch(API + '/api/audio', { headers: { Authorization: 'Bearer ' + token } });
      const data = await res.json();
      setAudioList(Array.isArray(data) ? data : []);
    } catch(e) { setAudioList([]); } finally { setAudioLoading(false); }
  };

  const uploadAudio = async () => {
    if (!audioFile || !audioUploadForm.title) { setAudioMsg('Judul dan file wajib diisi'); return; }
    setAudioUploading(true); setAudioMsg('');
    try {
      const fd = new FormData();
      fd.append('audio', audioFile);
      Object.entries(audioUploadForm).forEach(([k,v]) => fd.append(k, v));
      const res = await fetch(API + '/api/audio/admin-upload', { method:'POST', headers:{ Authorization:'Bearer '+token }, body:fd });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setAudioMsg('✅ Lagu berhasil diupload: ' + data.title);
      setAudioFile(null); setAudioUploadForm({title:'',artist:'',genre:'',mood:'',source:''});
      fetchAudioLibrary();
    } catch(e) { setAudioMsg('❌ ' + e.message); } finally { setAudioUploading(false); }
  };

  const deleteAudio = async (id, title) => {
    if (!window.confirm('Hapus lagu "' + title + '"?')) return;
    try {
      const res = await fetch(API + '/api/audio/admin/' + id, { method:'DELETE', headers:{ Authorization:'Bearer '+token } });
      if (!res.ok) throw new Error('Gagal hapus');
      setAudioMsg('✅ Lagu dihapus');
      fetchAudioLibrary();
    } catch(e) { setAudioMsg('❌ ' + e.message); }
  };
  const fetchVisualTemplates = async () => {
    setVisualLoading(true);
    try {
      const res = await fetch(API + '/api/ugc-templates-admin', { headers: { Authorization: 'Bearer ' + token } });
      const data = await res.json();
      setVisualList(Array.isArray(data) ? data : []);
    } catch(e) { setVisualList([]); } finally { setVisualLoading(false); }
  };
  const uploadVisualTemplate = async () => {
    if (!visualFile || !visualUploadForm.label) { setVisualMsg('Label dan file wajib diisi'); return; }
    setVisualUploading(true); setVisualMsg('');
    try {
      const fd = new FormData();
      fd.append('file', visualFile);
      Object.entries(visualUploadForm).forEach(([k,v]) => fd.append(k, v));
      const res = await fetch(API + '/api/ugc-templates-admin/upload', { method:'POST', headers:{ Authorization:'Bearer '+token }, body:fd });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      setVisualMsg('✅  Template berhasil diupload: ' + data.label);
      setVisualFile(null); setVisualUploadForm({type:'bg',label:'',source:''});
      fetchVisualTemplates();
    } catch(e) { setVisualMsg('❌  ' + e.message); } finally { setVisualUploading(false); }
  };
  const deleteVisualTemplate = async (id, label) => {
    if (!window.confirm('Hapus template "' + label + '"?')) return;
    try {
      const res = await fetch(API + '/api/ugc-templates-admin/' + id, { method:'DELETE', headers:{ Authorization:'Bearer '+token } });
      if (!res.ok) throw new Error('Gagal hapus');
      setVisualMsg('✅  Template dihapus');
      fetchVisualTemplates();
    } catch(e) { setVisualMsg('❌  ' + e.message); }
  };

  const navItems = [
    {id:'dashboard',icon:'📊',label:'Dashboard'},
    {id:'clients',icon:'👥',label:'Semua Client'},
    {id:'ai',icon:'✨',label:'AI Credits'},
    {id:'audio',icon:'🎵',label:'Audio Library'},
    {id:'ugc-templates',icon:'🎬',label:'Template UGC'},
    {id:'affiliate',icon:'🤝',label:'Affiliate Payout'},
    {id:'gprojects',icon:'📦',label:'Google Projects'},
  ];

  return (
    <>
      {sidebarOpen && <div onClick={()=>setSidebarOpen(false)} style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.6)',zIndex:40}} />}

      <div className="admin-topbar">
        <button onClick={()=>setSidebarOpen(!sidebarOpen)} style={{background:'transparent',border:'none',color:'#f1f5f9',fontSize:20,cursor:'pointer'}}>☰</button>
        <div style={{display:'flex',alignItems:'baseline',gap:4}}>
          <span style={{fontSize:20,fontWeight:800,background:'linear-gradient(135deg,#a06bff,#22d3ee)',WebkitBackgroundClip:'text',WebkitTextFillColor:'transparent'}}>18</span>
          <span style={{fontSize:9,fontWeight:600,color:'#ef4444',letterSpacing:3}}>ADMIN</span>
        </div>
        <div style={{width:28}} />
      </div>

      <div className="admin-root">
        <div className={`admin-sidebar${sidebarOpen?' open':''}`}>
          <div style={{display:'flex',alignItems:'baseline',gap:4,marginBottom:28}}>
            <span style={{fontSize:24,fontWeight:800,background:'linear-gradient(135deg,#a06bff,#22d3ee)',WebkitBackgroundClip:'text',WebkitTextFillColor:'transparent'}}>18</span>
            <span style={{fontSize:10,fontWeight:600,color:'#ef4444',letterSpacing:3}}>ADMIN</span>
          </div>
          <nav className="admin-nav" style={{display:'flex',flexDirection:'column',gap:4,flex:1,minHeight:0,overflowY:'auto'}}>
            {navItems.map(item=>(
              <button key={item.id} onClick={()=>{setPage(item.id);setSelectedClient(null);setSidebarOpen(false);}}
                style={{display:'flex',gap:10,alignItems:'center',padding:'10px 12px',borderRadius:8,border:'none',cursor:'pointer',fontSize:13,textAlign:'left',width:'100%',
                  background:page===item.id||page==='client-detail'&&item.id==='clients'?'rgba(255,255,255,0.075)':'transparent',
                  color:page===item.id||page==='client-detail'&&item.id==='clients'?'#a06bff':'#94a3b8',
                  borderLeft:page===item.id||page==='client-detail'&&item.id==='clients'?'2px solid #a06bff':'2px solid transparent'}}>
                <span>{item.icon}</span><span>{item.label}</span>
              </button>
            ))}
          </nav>
          {stats?.pending_yt_emails > 0 && (
            <div style={{background:'rgba(160,107,255,0.16)',border:'1px solid #a06bff',color:'#a06bff',fontSize:11,padding:'6px 10px',borderRadius:8,margin:'16px 0',textAlign:'center'}}>
              🔔 {stats.pending_yt_emails} YT email pending
            </div>
          )}
          {googleProjects.filter(p => p.quota_limit > 0 && (p.quota_used / p.quota_limit) >= 0.8).length > 0 && (
            <div onClick={()=>{setPage('gprojects');setSelectedClient(null);}} style={{background:'rgba(239,68,68,0.16)',border:'1px solid #ef4444',color:'#ef4444',fontSize:11,padding:'6px 10px',borderRadius:8,margin:'8px 0',textAlign:'center',cursor:'pointer'}}>
              ⚠️ {googleProjects.filter(p => p.quota_limit > 0 && (p.quota_used / p.quota_limit) >= 0.8).length} project kuota hampir habis
            </div>
          )}
          <div style={{marginTop:'auto'}}>
            <div style={{fontSize:11,color:'#64748b',marginBottom:8,textAlign:'center'}}>FZL420 x SM</div>
            <button onClick={logout} style={{width:'100%',padding:'8px 12px',background:'transparent',border:'1px solid rgba(255,255,255,0.12)',borderRadius:8,color:'#64748b',cursor:'pointer',fontSize:12,textAlign:'left'}}>↩ Logout</button>
          </div>
        </div>

        <div className="admin-main">
          {msg.text && (
            <div style={{background:msg.type==='error'?'rgba(239,68,68,0.16)':'rgba(16,185,129,0.16)',color:msg.type==='error'?'#ef4444':'#10b981',padding:'10px 14px',borderRadius:8,fontSize:13,marginBottom:16}}>
              {msg.text}
            </div>
          )}

          {page==='dashboard' && (
            <div>
              <h1 style={{fontSize:20,fontWeight:700,color:'#f1f5f9',marginBottom:20}}>Dashboard</h1>
              {stats && (
                <div className="admin-stats">
                  {[
                    {l:'Total Client',v:stats.total_clients,c:'#a06bff',i:'👥'},
                    {l:'Subscriber',v:stats.active_subscriptions,c:'#10b981',i:'⭐'},
                    {l:'Total Jobs',v:stats.total_jobs,c:'#3b82f6',i:'📋'},
                    {l:'Jobs Hari Ini',v:stats.jobs_today,c:'#a06bff',i:'📤'},
                    {l:'Gagal',v:stats.failed_today,c:'#ef4444',i:'❌'},
                    {l:'YT Pending',v:stats.pending_yt_emails,c:'#a06bff',i:'🔔'},
                  ].map(s=>(
                    <div key={s.l} style={{background:'rgba(255,255,255,0.055)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:12,padding:14,textAlign:'center'}}>
                      <div style={{fontSize:20,marginBottom:4}}>{s.i}</div>
                      <div style={{fontSize:22,fontWeight:700,color:s.c}}>{s.v}</div>
                      <div style={{fontSize:11,color:'#64748b',marginTop:2}}>{s.l}</div>
                    </div>
                  ))}
                </div>
              )}
              <div style={{background:'rgba(255,255,255,0.055)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:12,padding:20,marginTop:20}}>
                <h2 style={{fontSize:14,fontWeight:600,color:'#f1f5f9',marginBottom:14}}>Client Terbaru</h2>
                <ClientList clients={clients.slice(0,5)} onDetail={fetchClientDetail} />
              </div>
            </div>
          )}

          {page==='clients' && !selectedClient && (
            <div>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:20,flexWrap:'wrap',gap:10}}>
                <h1 style={{fontSize:20,fontWeight:700,color:'#f1f5f9'}}>Client ({clients.length})</h1>
                <button onClick={()=>{fetchStats();fetchClients();}} style={{background:'transparent',border:'1px solid rgba(255,255,255,0.12)',color:'#94a3b8',padding:'8px 14px',borderRadius:8,cursor:'pointer',fontSize:13}}>🔄 Refresh</button>
              </div>
              <div style={{background:'rgba(255,255,255,0.055)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:12,padding:20}}>
                <ClientList clients={clients} onDetail={fetchClientDetail} />
              </div>
            </div>
          )}

          {page==='client-detail' && selectedClient && (
            <div>
              <button onClick={()=>{setPage('clients');setSelectedClient(null);}} style={{background:'transparent',border:'1px solid rgba(255,255,255,0.12)',color:'#94a3b8',padding:'8px 14px',borderRadius:8,cursor:'pointer',fontSize:13,marginBottom:16}}>← Kembali</button>
              <h1 style={{fontSize:20,fontWeight:700,color:'#f1f5f9',marginBottom:16}}>{selectedClient.client?.name}</h1>

              <div className="admin-detail-grid">
                <div style={{background:'rgba(255,255,255,0.055)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:12,padding:20}}>
                  <h3 style={{fontSize:14,fontWeight:600,color:'#f1f5f9',marginBottom:14}}>👤 Info Client</h3>
                  {[['Email',selectedClient.client?.email],['Artis',selectedClient.client?.artist_name||'-'],['WA',selectedClient.client?.phone||'-'],['Status',selectedClient.client?.status],['Plan',selectedClient.client?.plan||'FREE'],['Expired',selectedClient.client?.expires_at?new Date(selectedClient.client.expires_at).toLocaleDateString('id-ID'):'-'],['Channel YT',selectedClient.channels?.length||0],['Akun TikTok',clientTiktok.length]].map(([k,v])=>(
                    <div key={k} style={{display:'flex',justifyContent:'space-between',padding:'7px 0',borderBottom:'1px solid rgba(255,255,255,0.12)',fontSize:12}}>
                      <span style={{color:'#64748b'}}>{k}</span>
                      <span style={{color:'#f1f5f9',fontWeight:500,wordBreak:'break-all',textAlign:'right',maxWidth:'60%'}}>{v}</span>
                    </div>
                  ))}
                </div>
                <div style={{background:'rgba(255,255,255,0.055)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:12,padding:20}}>
                  <h3 style={{fontSize:14,fontWeight:600,color:'#f1f5f9',marginBottom:14}}>⭐ Subscription</h3>
                  {['starter','medium','mega'].map(plan=>(
                    <button key={plan} onClick={()=>setSubscription(selectedClient.client?.id,plan)}
                      style={{background:'linear-gradient(135deg,#a06bff,#22d3ee)',color:'#000',padding:'10px',border:'none',borderRadius:8,fontWeight:700,cursor:'pointer',width:'100%',marginBottom:8,fontSize:13}}>
                      {plan.toUpperCase()} — 30 hari
                    </button>
                  ))}
                  <button onClick={()=>toggleUgcAccess(selectedClient.client?.id, selectedClient.client?.ugc_enabled)}
                    style={{padding:'8px 16px',background: selectedClient.client?.ugc_enabled ? 'rgba(239,68,68,0.16)':'rgba(160,107,255,0.16)',border:'1px solid '+(selectedClient.client?.ugc_enabled?'#ef4444':'#a06bff'),color: selectedClient.client?.ugc_enabled?'#ef4444':'#a06bff',borderRadius:8,cursor:'pointer',fontSize:13,marginRight:8}}>
                    {selectedClient.client?.ugc_enabled ? '🎬 Matikan UGC' : '🎬 Aktifkan UGC'}
                  </button>
                  <button onClick={()=>toggleUrlSource(selectedClient.client?.id, selectedClient.client?.url_source_enabled)}
                    title="OFF: klien hanya bisa upload file (repost & lagu UGC). Disarankan OFF untuk audit YouTube API."
                    style={{padding:'8px 16px',background: selectedClient.client?.url_source_enabled ? 'rgba(239,68,68,0.16)':'rgba(34,211,238,0.14)',border:'1px solid '+(selectedClient.client?.url_source_enabled?'#ef4444':'#22d3ee'),color: selectedClient.client?.url_source_enabled?'#ef4444':'#22d3ee',borderRadius:8,cursor:'pointer',fontSize:13,marginRight:8,marginTop:8}}>
                    {selectedClient.client?.url_source_enabled ? '🔗 Matikan Sumber URL' : '🔗 Aktifkan Sumber URL'}
                  </button>
                  <button onClick={()=>toggleStatus(selectedClient.client?.id,selectedClient.client?.status)}
                    style={{background:'transparent',border:'1px solid #ef4444',color:'#ef4444',padding:'8px',borderRadius:8,cursor:'pointer',width:'100%',fontSize:13,marginTop:4}}>
                    {selectedClient.client?.status==='active'?'🔒 Suspend':'✅ Aktifkan'}
                  </button>
                  <button onClick={()=>deleteClient(selectedClient.client?.id, selectedClient.client?.email)}
                    style={{background:'rgba(239,68,68,0.16)',border:'1px solid #ef4444',color:'#ef4444',padding:'8px',borderRadius:8,cursor:'pointer',width:'100%',fontSize:13,marginTop:4,fontWeight:700}}>
                    🗑️ Hapus Client
                  </button>
                  <div style={{borderTop:'1px solid rgba(255,255,255,0.12)',marginTop:12,paddingTop:12}}>
                    <div style={{fontSize:12,color:'#64748b',marginBottom:8}}>Invoice:</div>
                    <button onClick={()=>previewInvoice(selectedClient.client?.id)}
                      style={{background:'transparent',border:'1px solid #3b82f6',color:'#3b82f6',padding:'8px',borderRadius:8,cursor:'pointer',width:'100%',fontSize:13,marginBottom:6}}>
                      👁️ Preview Invoice
                    </button>
                    <button onClick={()=>sendInvoice(selectedClient.client?.id, selectedClient.client?.email)}
                      style={{background:'linear-gradient(135deg,#10b981,#059669)',border:'none',color:'#fff',padding:'8px',borderRadius:8,cursor:'pointer',width:'100%',fontSize:13,fontWeight:700}}>
                      📧 Kirim Invoice
                    </button>
                  </div>
                </div>
              </div>

              {/* Quota & Cookie Control */}
              <div style={{background:'rgba(255,255,255,0.055)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:12,padding:20,marginTop:16}}>
                <h3 style={{fontSize:14,fontWeight:600,color:'#f1f5f9',marginBottom:14}}>🎛️ Quota & Cookie Control</h3>
                <div style={{marginBottom:16}}>
                  <div style={{fontSize:13,color:'#94a3b8',marginBottom:8}}>Tambah extra limit upload hari ini:</div>
                  <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
                    {[1,3,5,10].map(n=>(
                      <button key={n} onClick={()=>addExtraLimit(selectedClient.client?.id, n)}
                        style={{padding:'6px 14px',background:'linear-gradient(135deg,#10b981,#059669)',border:'none',borderRadius:8,color:'#fff',fontSize:13,fontWeight:600,cursor:'pointer'}}>
                        +{n} limit
                      </button>
                    ))}
                  </div>
                </div>
                {selectedClient.channels?.length > 0 && (
                  <div>
                    <div style={{fontSize:13,color:'#94a3b8',marginBottom:8}}>Cookie per Channel:</div>
                    {cookieMsg && <div style={{fontSize:12,color:cookieMsg.startsWith('✅')?'#10b981':'#ef4444',marginBottom:8,padding:'6px 10px',background:'rgba(255,255,255,0.075)',borderRadius:6}}>{cookieMsg}</div>}
                    {selectedClient.channels.map(ch=>(
                      <div key={ch.id} style={{background:'rgba(255,255,255,0.075)',borderRadius:8,marginBottom:8,padding:'10px 12px'}}>
                        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8}}>
                          <span style={{fontSize:13,color:'#f1f5f9',fontWeight:600}}>{ch.channel_name}</span>
                          <button onClick={()=>resetCookie(ch.id, selectedClient.client?.id)}
                            style={{padding:'3px 10px',background:'rgba(239,68,68,0.16)',border:'1px solid #ef4444',color:'#ef4444',borderRadius:6,cursor:'pointer',fontSize:11}}>
                            ⚠️ Reset
                          </button>
                        </div>
                        <textarea
                          placeholder="Paste cookie Netscape format di sini..."
                          value={cookieInputs[ch.id] || ''}
                          onChange={e => setCookieInputs(prev => ({...prev, [ch.id]: e.target.value}))}
                          style={{width:'100%',height:80,padding:'8px',background:'#0f1729',border:'1px solid rgba(255,255,255,0.12)',borderRadius:6,color:'#94a3b8',fontSize:10,fontFamily:'monospace',resize:'vertical',marginBottom:6}}
                        />
                        <button onClick={()=>updateCookie(ch.id, selectedClient.client?.id)}
                          style={{width:'100%',padding:'6px',background:'linear-gradient(135deg,#10b981,#059669)',border:'none',borderRadius:6,color:'#fff',fontSize:12,fontWeight:600,cursor:'pointer'}}>
                          💾 Update Cookie
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Instagram / Postiz */}
              <div style={{background:'rgba(255,255,255,0.055)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:12,padding:20,marginTop:16}}>
                <h3 style={{fontSize:14,fontWeight:600,color:'#f1f5f9',marginBottom:14}}>📸 Instagram / Postiz</h3>
                <div style={{display:'flex',justifyContent:'space-between',padding:'7px 0',borderBottom:'1px solid rgba(255,255,255,0.12)',fontSize:12,marginBottom:12}}>
                  <span style={{color:'#64748b'}}>Status Postiz</span>
                  <span style={{color:selectedClient.client?.postiz_api_key?'#10b981':'#ef4444',fontWeight:600}}>
                    {selectedClient.client?.postiz_api_key ? '✅ Sudah disetup' : '❌ Belum disetup'}
                  </span>
                </div>
                <div style={{display:'flex',justifyContent:'space-between',padding:'7px 0',borderBottom:'1px solid rgba(255,255,255,0.12)',fontSize:12,marginBottom:12}}>
                  <span style={{color:'#64748b'}}>Instagram Connected</span>
                  <span style={{color:selectedClient.client?.ig_connected?'#10b981':'#64748b',fontWeight:600}}>
                    {selectedClient.client?.ig_connected ? `✅ @${selectedClient.client?.ig_username||'connected'}` : '— Belum connect'}
                  </span>
                </div>
                <button onClick={()=>setupPostiz(selectedClient.client?.id)}
                  style={{padding:'8px 14px',background:selectedClient.client?.postiz_api_key?'transparent':'linear-gradient(135deg,#a06bff,#22d3ee)',border:selectedClient.client?.postiz_api_key?'1px solid rgba(255,255,255,0.12)':'none',color:selectedClient.client?.postiz_api_key?'#94a3b8':'#000',borderRadius:8,cursor:'pointer',fontSize:13,fontWeight:600,width:'100%'}}>
                  {selectedClient.client?.postiz_api_key ? '🔄 Re-setup Postiz' : '🚀 Setup Postiz untuk Client'}
                </button>
                {selectedClient.client?.postiz_api_key && (
                  <a href="https://postiz.eighteen-media.id/integrations/social/instagram-standalone" target="_blank" rel="noreferrer"
                    style={{display:'block',textAlign:'center',marginTop:8,padding:'8px 14px',background:'transparent',border:'1px solid #a06bff',color:'#a06bff',borderRadius:8,fontSize:12,textDecoration:'none'}}>
                    🔗 Buka Postiz untuk Connect Instagram
                  </a>
                )}
              </div>

              {/* TikTok Accounts */}
              <div style={{background:'rgba(255,255,255,0.055)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:12,padding:20,marginTop:16}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:14,flexWrap:'wrap',gap:8}}>
                  <h3 style={{fontSize:14,fontWeight:600,color:'#f1f5f9'}}>🎵 Akun TikTok</h3>
                  <span style={{fontSize:11,color:'#64748b'}}>{clientTiktok.filter(a=>!a.needs_reconnect).length}/{clientTiktok.length} aktif</span>
                </div>
                {clientTiktok.length === 0 ? (
                  <div style={{textAlign:'center',padding:16,color:'#64748b',fontSize:13,background:'rgba(255,255,255,0.075)',borderRadius:8}}>
                    Belum ada akun TikTok terhubung
                  </div>
                ) : clientTiktok.map(acc => (
                  <div key={acc.id} style={{padding:'12px 14px',background:'rgba(255,255,255,0.075)',borderRadius:10,marginBottom:8,border:`1px solid ${acc.needs_reconnect?'#ef4444':'rgba(255,255,255,0.12)'}`}}>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',gap:8,flexWrap:'wrap'}}>
                      <div style={{display:'flex',alignItems:'center',gap:10,flex:1}}>
                        <div style={{width:32,height:32,borderRadius:'50%',background:acc.avatar_url?'transparent':'linear-gradient(135deg,#000,#333)',flexShrink:0,overflow:'hidden',display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontSize:12,fontWeight:700}}>
                          {acc.avatar_url ? <img src={acc.avatar_url} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}} /> : (acc.display_name?.charAt(0)||'T')}
                        </div>
                        <div>
                          <div style={{fontSize:13,fontWeight:600,color:'#f1f5f9'}}>{acc.display_name || acc.username || 'Unknown'}</div>
                          {acc.username && <div style={{fontSize:11,color:'#64748b'}}>@{acc.username}</div>}
                          <div style={{fontSize:10,color:'#475569',marginTop:2}}>ID: {acc.open_id?.substring(0,20)}...</div>
                        </div>
                      </div>
                      <div style={{display:'flex',flexDirection:'column',alignItems:'flex-end',gap:6}}>
                        <span style={{padding:'2px 8px',borderRadius:999,fontSize:10,fontWeight:600,background:acc.needs_reconnect?'rgba(239,68,68,0.16)':'rgba(16,185,129,0.16)',color:acc.needs_reconnect?'#ef4444':'#10b981'}}>
                          {acc.needs_reconnect ? '⚠️ Reconnect' : '✅ Aktif'}
                        </span>
                        <button onClick={()=>deleteTiktokAccount(acc.id, acc.display_name||acc.username||'Unknown', selectedClient.client?.id)}
                          style={{padding:'3px 10px',background:'rgba(239,68,68,0.16)',border:'1px solid #ef4444',color:'#ef4444',borderRadius:6,cursor:'pointer',fontSize:11}}>
                          🗑 Hapus
                        </button>
                      </div>
                    </div>
                    <div style={{fontSize:11,color:'#64748b',marginTop:8}}>
                      Terhubung: {new Date(acc.created_at).toLocaleDateString('id-ID', {day:'numeric',month:'short',year:'numeric'})}
                    </div>
                    <div style={{display:'flex',alignItems:'center',gap:6,marginTop:8}}>
                      <span style={{fontSize:11,color:'#64748b'}}>Cap posting harian:</span>
                      <input type="number" min={1} max={15} defaultValue={acc.daily_post_cap ?? 10}
                        id={`ttcap-${acc.id}`}
                        style={{width:50,padding:'3px 6px',background:'rgba(255,255,255,0.075)',border:'1px solid rgba(255,255,255,0.18)',borderRadius:6,color:'#f1f5f9',fontSize:11}}/>
                      <button onClick={()=>updateTiktokDailyCap(acc.id, document.getElementById(`ttcap-${acc.id}`).value, selectedClient.client?.id)}
                        style={{padding:'3px 10px',background:'rgba(160,107,255,0.16)',border:'1px solid #a06bff',color:'#a06bff',borderRadius:6,cursor:'pointer',fontSize:11}}>
                        Simpan
                      </button>
                    </div>
                    {acc.token_error && (
                      <div style={{fontSize:11,color:'#ef4444',marginTop:6,padding:'4px 8px',background:'rgba(239,68,68,0.16)',borderRadius:4}}>
                        ⚠️ {acc.token_error}
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {/* AI Credits */}
              <div style={{background:'rgba(255,255,255,0.055)',border:'1px solid #7b3fe4',borderRadius:12,padding:20,marginTop:16}}>
                <h3 style={{fontSize:14,fontWeight:600,color:'#f1f5f9',marginBottom:14}}>✨ AI Credits Client</h3>
                {(() => {
                  const aiClient = aiClients.find(c=>c.id===selectedClient.client?.id);
                  return (
                    <div>
                      <div style={{fontSize:22,fontWeight:700,color:'#a06bff',marginBottom:12}}>{aiClient?.balance||0} kredit</div>
                      <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
                        {[10,30,100].map(amt=>(
                          <button key={amt} onClick={()=>topupCredits(selectedClient.client?.id, amt)}
                            style={{padding:'6px 14px',background:'linear-gradient(135deg,#7b3fe4,#a06bff)',border:'none',borderRadius:8,color:'#fff',fontSize:13,fontWeight:600,cursor:'pointer'}}>
                            +{amt} kredit
                          </button>
                        ))}
                      </div>
                    </div>
                  );
                })()}
              </div>

              {/* YT Emails */}
              <div style={{background:'rgba(255,255,255,0.055)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:12,padding:20,marginTop:16}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:14,flexWrap:'wrap',gap:8}}>
                  <h3 style={{fontSize:14,fontWeight:600,color:'#f1f5f9'}}>📺 Email YouTube</h3>
                  <span style={{fontSize:11,color:'#64748b'}}>{selectedClient.yt_emails?.filter(e=>e.status==='connected').length||0}/{selectedClient.yt_emails?.length||0} connected</span>
                </div>
                {!selectedClient.yt_emails?.length ? (
                  <div style={{textAlign:'center',padding:16,color:'#64748b',fontSize:13,background:'rgba(255,255,255,0.075)',borderRadius:8}}>Belum ada email</div>
                ) : selectedClient.yt_emails?.map(e=>(
                  <div key={e.id} style={{padding:'12px 14px',background:'rgba(255,255,255,0.075)',borderRadius:10,marginBottom:8,border:`1px solid ${e.status==='connected'?'#10b981':'rgba(255,255,255,0.12)'}`}}>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',gap:8,flexWrap:'wrap',marginBottom:8}}>
                      <div style={{flex:1}}>
                        <div style={{fontSize:13,fontWeight:500,color:'#f1f5f9',wordBreak:'break-all'}}>{e.email}</div>
                        <div style={{fontSize:11,color:'#64748b',marginTop:2}}>{new Date(e.added_at).toLocaleDateString('id-ID')}</div>
                      </div>
                      <span style={{padding:'3px 8px',borderRadius:999,fontSize:10,fontWeight:600,flexShrink:0,background:e.status==='connected'?'rgba(16,185,129,0.16)':'rgba(160,107,255,0.16)',color:e.status==='connected'?'#10b981':'#a06bff'}}>
                        {e.status==='connected'?'✅':'⏳'} {e.status}
                      </span>
                    </div>
                    <button onClick={()=>toggleYtEmail(e.id,e.status,selectedClient.client?.id)}
                      style={{width:'100%',padding:'7px',borderRadius:8,border:'none',background:e.status==='connected'?'rgba(239,68,68,0.16)':'rgba(16,185,129,0.16)',color:e.status==='connected'?'#ef4444':'#10b981',cursor:'pointer',fontSize:12,fontWeight:600}}>
                      {e.status==='connected'?'✗ Unmark':'✓ Mark Connected'}
                    </button>
                  </div>
                ))}
              </div>

              {/* Jobs */}
              <div style={{background:'rgba(255,255,255,0.055)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:12,padding:20,marginTop:16}}>
                <h3 style={{fontSize:14,fontWeight:600,color:'#f1f5f9',marginBottom:14}}>📋 Riwayat Job ({selectedClient.jobs?.length})</h3>
                {selectedClient.jobs?.map(job=>(
                  <div key={job.id} style={{padding:'10px 0',borderBottom:'1px solid rgba(255,255,255,0.075)'}}>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',gap:8,flexWrap:'wrap'}}>
                      <a href={job.youtube_url} target="_blank" rel="noreferrer" style={{color:'#a06bff',fontSize:11,flex:1,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                        {job.youtube_url?.substring(0,38)}...
                      </a>
                      <span style={{padding:'2px 8px',borderRadius:999,fontSize:10,flexShrink:0,background:job.status==='done'?'rgba(16,185,129,0.16)':job.status==='failed'?'rgba(239,68,68,0.16)':'rgba(160,107,255,0.16)',color:job.status==='done'?'#10b981':job.status==='failed'?'#ef4444':'#a06bff'}}>
                        {job.status}
                      </span>
                    </div>
                    <div style={{fontSize:11,color:'#64748b',marginTop:3}}>{new Date(job.created_at).toLocaleDateString('id-ID')}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {page==='affiliate' && (
            <div>
              <h1 style={{fontSize:20,fontWeight:700,color:'#f1f5f9',marginBottom:20}}>🤝 Affiliate Payout</h1>
              {payoutMsg && <div style={{padding:'10px 14px',borderRadius:8,background:payoutMsg.startsWith('✅')?'rgba(16,185,129,0.16)':'rgba(239,68,68,0.16)',color:payoutMsg.startsWith('✅')?'#10b981':'#ef4444',marginBottom:16,fontSize:13}}>{payoutMsg}</div>}
              <div style={{background:'rgba(255,255,255,0.055)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:12,padding:20}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
                  <h2 style={{fontSize:15,fontWeight:600,color:'#f1f5f9'}}>📋 Request Pencairan ({payoutList.length})</h2>
                  <button onClick={fetchPayouts} style={{padding:'6px 14px',background:'transparent',border:'1px solid rgba(255,255,255,0.12)',color:'#94a3b8',borderRadius:6,cursor:'pointer',fontSize:12}}>🔄 Refresh</button>
                </div>
                {payoutList.length === 0 && !payoutLoading && <div style={{textAlign:'center',color:'#64748b',padding:32}}>
                  <div style={{fontSize:32,marginBottom:8}}>🤝</div>
                  <div>Belum ada request pencairan</div>
                  <button onClick={fetchPayouts} style={{marginTop:12,padding:'8px 16px',background:'#a06bff',color:'rgba(255,255,255,0.04)',border:'none',borderRadius:8,cursor:'pointer',fontWeight:600}}>Load Data</button>
                </div>}
                {payoutLoading && <div style={{textAlign:'center',color:'#64748b',padding:32}}>Loading...</div>}
                {payoutList.map(p => (
                  <div key={p.id} style={{background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:10,padding:16,marginBottom:12}}>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:12}}>
                      <div>
                        <div style={{fontWeight:700,fontSize:14,color:'#f1f5f9'}}>{p.username} <span style={{fontSize:11,color:'#64748b'}}>({p.email})</span></div>
                        <div style={{fontSize:22,fontWeight:800,color:'#a06bff',marginTop:4}}>Rp {Math.round(p.amount).toLocaleString('id-ID')}</div>
                        <div style={{fontSize:11,color:'#64748b',marginTop:4}}>Request: {new Date(p.requested_at).toLocaleString('id-ID')}</div>
                      </div>
                      <span style={{fontSize:11,padding:'4px 10px',borderRadius:999,background:p.status==='paid'?'rgba(16,185,129,0.16)':p.status==='rejected'?'rgba(239,68,68,0.16)':'rgba(255,255,255,0.075)',color:p.status==='paid'?'#10b981':p.status==='rejected'?'#ef4444':'#a06bff',fontWeight:600}}>
                        {p.status==='paid'?'✅ Dibayar':p.status==='rejected'?'❌ Ditolak':'⏳ Pending'}
                      </span>
                    </div>
                    <div style={{background:'rgba(255,255,255,0.055)',borderRadius:8,padding:'10px 12px',marginBottom:12}}>
                      <div style={{fontSize:12,color:'#94a3b8',marginBottom:4}}>📦 Detail Transfer:</div>
                      <div style={{fontSize:13,color:'#f1f5f9',fontWeight:600}}>{p.bank_name}</div>
                      <div style={{fontSize:12,color:'#f1f5f9'}}>No. Rek: {p.account_number}</div>
                      <div style={{fontSize:12,color:'#64748b'}}>A/N: {p.account_name}</div>
                    </div>
                    {p.status === 'pending' && (
                      <div style={{display:'flex',gap:8}}>
                        <button onClick={()=>{
                          const note = window.prompt('Catatan (opsional):') || '';
                          if(window.confirm('Tandai sebagai SUDAH DIBAYAR?')) updatePayout(p.id,'paid',note);
                        }} style={{flex:1,padding:'10px 0',background:'rgba(16,185,129,0.16)',border:'1px solid #10b981',color:'#10b981',borderRadius:8,cursor:'pointer',fontWeight:700,fontSize:13}}>
                          ✅ Tandai Dibayar
                        </button>
                        <button onClick={()=>{
                          const note = window.prompt('Alasan penolakan:') || 'Ditolak admin';
                          if(window.confirm('TOLAK request ini?')) updatePayout(p.id,'rejected',note);
                        }} style={{flex:1,padding:'10px 0',background:'rgba(239,68,68,0.16)',border:'1px solid #ef4444',color:'#ef4444',borderRadius:8,cursor:'pointer',fontWeight:700,fontSize:13}}>
                          ❌ Tolak
                        </button>
                      </div>
                    )}
                    {p.admin_note && <div style={{fontSize:11,color:'#94a3b8',marginTop:8}}>Catatan: {p.admin_note}</div>}
                    {p.paid_at && <div style={{fontSize:11,color:'#10b981',marginTop:4}}>Dibayar: {new Date(p.paid_at).toLocaleString('id-ID')}</div>}
                  </div>
                ))}
              </div>
            </div>
          )}
          {page==='ugc-templates' && (
            <div>
              <h1 style={{fontSize:20,fontWeight:700,color:'#f1f5f9',marginBottom:20}}>🎬  Template UGC</h1>
              {visualMsg && <div style={{padding:'10px 14px',borderRadius:8,background:visualMsg.startsWith('✅ ')?'rgba(16,185,129,0.16)':'rgba(239,68,68,0.16)',color:visualMsg.startsWith('✅ ')?'#10b981':'#ef4444',marginBottom:16,fontSize:13}}>{visualMsg}</div>}
              <div style={{background:'rgba(255,255,255,0.055)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:12,padding:20,marginBottom:20}}>
                <h2 style={{fontSize:15,fontWeight:600,color:'#f1f5f9',marginBottom:16}}>➕  Upload Template Baru</h2>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:10}}>
                  <div><label style={{fontSize:12,color:'#94a3b8',display:'block',marginBottom:4}}>Tipe *</label>
                    <select value={visualUploadForm.type} onChange={e=>setVisualUploadForm({...visualUploadForm,type:e.target.value})} style={{width:'100%',padding:'8px 12px',background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:8,color:'#f1f5f9',fontSize:13,boxSizing:'border-box'}}>
                      <option value="bg">Background</option>
                      <option value="motion">Motion Layer (Overlay)</option>
                    </select></div>
                  <div><label style={{fontSize:12,color:'#94a3b8',display:'block',marginBottom:4}}>Label *</label>
                    <input value={visualUploadForm.label} onChange={e=>setVisualUploadForm({...visualUploadForm,label:e.target.value})} placeholder="mis. Salju Turun, Gradient Ungu..." style={{width:'100%',padding:'8px 12px',background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:8,color:'#f1f5f9',fontSize:13,boxSizing:'border-box'}}/></div>
                </div>
                <div style={{marginBottom:10}}><label style={{fontSize:12,color:'#94a3b8',display:'block',marginBottom:4}}>Sumber / Credit</label>
                  <input value={visualUploadForm.source} onChange={e=>setVisualUploadForm({...visualUploadForm,source:e.target.value})} placeholder="mis. Pixabay, FX Elements..." style={{width:'100%',padding:'8px 12px',background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:8,color:'#f1f5f9',fontSize:13,boxSizing:'border-box'}}/></div>
                <div style={{marginBottom:12}}>
                  <label style={{fontSize:12,color:'#94a3b8',display:'block',marginBottom:4}}>File * (MP4/MOV/JPG/PNG, max 100MB)</label>
                  <div onClick={()=>document.getElementById('admin-visual-input').click()} style={{border:'2px dashed '+(visualFile?'#f97316':'rgba(255,255,255,0.12)'),borderRadius:8,padding:'16px',textAlign:'center',cursor:'pointer',background:'rgba(255,255,255,0.04)'}}>
                    {visualFile ? <span style={{color:'#f97316',fontWeight:600}}>✅  {visualFile.name} ({(visualFile.size/1024/1024).toFixed(1)}MB)</span>
                      : <span style={{color:'#64748b'}}>🎬 Klik untuk pilih file MP4/MOV/JPG/PNG</span>}
                  </div>
                  <input id="admin-visual-input" type="file" accept=".mp4,.mov,.webm,.jpg,.jpeg,.png,.webp,video/*,image/*" style={{display:'none'}}
                    onChange={e=>{const f=e.target.files[0];if(f&&f.size<=100*1024*1024)setVisualFile(f);else setVisualMsg('File terlalu besar, max 100MB');}}/>
                  {visualFile && (
                    /\.(mp4|mov)$/i.test(visualFile.name)
                      ? <video src={URL.createObjectURL(visualFile)} controls muted style={{width:'100%',maxHeight:220,borderRadius:8,marginTop:10,background:'#000'}} />
                      : <img src={URL.createObjectURL(visualFile)} alt="preview" style={{width:'100%',maxHeight:220,objectFit:'contain',borderRadius:8,marginTop:10,background:'#000'}} />
                  )}
                </div>
                <button onClick={uploadVisualTemplate} disabled={visualUploading||!visualFile||!visualUploadForm.label}
                  style={{padding:'10px 24px',background:(!visualFile||!visualUploadForm.label)?'rgba(255,255,255,0.12)':'#f97316',color:(!visualFile||!visualUploadForm.label)?'#475569':'#0a0a0a',border:'none',borderRadius:8,fontWeight:700,fontSize:13,cursor:(!visualFile||!visualUploadForm.label)?'not-allowed':'pointer'}}>
                  {visualUploading?'⏳  Mengupload...':'⬆️ Upload Template'}
                </button>
              </div>
              <div style={{background:'rgba(255,255,255,0.055)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:12,padding:20}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
                  <h2 style={{fontSize:15,fontWeight:600,color:'#f1f5f9'}}>📋 Daftar Template ({visualList.length})</h2>
                  <button onClick={fetchVisualTemplates} style={{padding:'6px 14px',background:'transparent',border:'1px solid rgba(255,255,255,0.12)',color:'#94a3b8',borderRadius:6,cursor:'pointer',fontSize:12}}>🔄 Refresh</button>
                </div>
                {visualLoading ? <div style={{textAlign:'center',color:'#64748b',padding:32}}>Loading...</div>
                : visualList.length === 0 ? <div style={{textAlign:'center',color:'#64748b',padding:32}}>Belum ada template</div>
                : <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                  {visualList.map(v => (
                    <div key={v.id} style={{background:'rgba(255,255,255,0.04)',borderRadius:10,border:'1px solid rgba(255,255,255,0.12)',padding:'12px 14px'}}>
                      <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:8}}>
                        <span style={{fontSize:10,padding:'2px 8px',borderRadius:6,background:v.type==='bg'?'rgba(59,130,246,0.16)':'rgba(249,115,22,0.16)',color:v.type==='bg'?'#3b82f6':'#f97316',fontWeight:700}}>{v.type==='bg'?'BACKGROUND':'MOTION LAYER'}</span>
                      </div>
                      <div style={{fontWeight:600,fontSize:13,color:'#f1f5f9',marginBottom:2}}>{v.label}</div>
                      {v.source && <div style={{fontSize:10,color:'#475569',marginBottom:8}}>Sumber: {v.source}</div>}
                      {/\.(mp4|mov)$/i.test(v.filename)
                        ? <video src={API+'/api/ugc-templates-admin/file/'+v.type+'/'+v.filename} controls muted style={{width:'100%',maxHeight:160,borderRadius:8,background:'#000'}} />
                        : <img src={API+'/api/ugc-templates-admin/file/'+v.type+'/'+v.filename} alt={v.label} style={{width:'100%',maxHeight:160,objectFit:'cover',borderRadius:8,background:'#000'}} />}
                      <button onClick={()=>deleteVisualTemplate(v.id,v.label)} style={{marginTop:8,width:'100%',padding:'6px 10px',background:'rgba(239,68,68,0.16)',border:'1px solid #ef4444',color:'#ef4444',borderRadius:6,cursor:'pointer',fontSize:11}}>🗑️  Hapus</button>
                    </div>
                  ))}
                </div>}
              </div>
            </div>
          )}
          {page==='audio' && (
            <div>
              <h1 style={{fontSize:20,fontWeight:700,color:'#f1f5f9',marginBottom:20}}>🎵 Audio Library</h1>
              {audioMsg && <div style={{padding:'10px 14px',borderRadius:8,background:audioMsg.startsWith('✅')?'rgba(16,185,129,0.16)':'rgba(239,68,68,0.16)',color:audioMsg.startsWith('✅')?'#10b981':'#ef4444',marginBottom:16,fontSize:13}}>{audioMsg}</div>}

              {/* Upload Form */}
              <div style={{background:'rgba(255,255,255,0.055)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:12,padding:20,marginBottom:20}}>
                <h2 style={{fontSize:15,fontWeight:600,color:'#f1f5f9',marginBottom:16}}>➕ Upload Lagu Baru</h2>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:10}}>
                  <div><label style={{fontSize:12,color:'#94a3b8',display:'block',marginBottom:4}}>Judul *</label>
                    <input value={audioUploadForm.title} onChange={e=>setAudioUploadForm({...audioUploadForm,title:e.target.value})} placeholder="Judul lagu..." style={{width:'100%',padding:'8px 12px',background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:8,color:'#f1f5f9',fontSize:13,boxSizing:'border-box'}}/></div>
                  <div><label style={{fontSize:12,color:'#94a3b8',display:'block',marginBottom:4}}>Artist</label>
                    <input value={audioUploadForm.artist} onChange={e=>setAudioUploadForm({...audioUploadForm,artist:e.target.value})} placeholder="Nama artist..." style={{width:'100%',padding:'8px 12px',background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:8,color:'#f1f5f9',fontSize:13,boxSizing:'border-box'}}/></div>
                  <div><label style={{fontSize:12,color:'#94a3b8',display:'block',marginBottom:4}}>Genre</label>
                    <select value={audioUploadForm.genre} onChange={e=>setAudioUploadForm({...audioUploadForm,genre:e.target.value})} style={{width:'100%',padding:'8px 12px',background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:8,color:'#f1f5f9',fontSize:13,boxSizing:'border-box'}}>
                      <option value="">Pilih genre...</option>
                      {['Pop','Electronic','Ambient','Jazz','Acoustic','Hip-Hop','Cinematic','Folk','RnB','Dangdut'].map(g=><option key={g} value={g}>{g}</option>)}
                    </select></div>
                  <div><label style={{fontSize:12,color:'#94a3b8',display:'block',marginBottom:4}}>Mood</label>
                    <select value={audioUploadForm.mood} onChange={e=>setAudioUploadForm({...audioUploadForm,mood:e.target.value})} style={{width:'100%',padding:'8px 12px',background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:8,color:'#f1f5f9',fontSize:13,boxSizing:'border-box'}}>
                      <option value="">Pilih mood...</option>
                      {['Energetic','Chill','Happy','Sad','Romantic','Epic','Relaxing','Motivational'].map(m=><option key={m} value={m}>{m}</option>)}
                    </select></div>
                </div>
                <div style={{marginBottom:10}}><label style={{fontSize:12,color:'#94a3b8',display:'block',marginBottom:4}}>Sumber / Credit</label>
                  <input value={audioUploadForm.source} onChange={e=>setAudioUploadForm({...audioUploadForm,source:e.target.value})} placeholder="mis. Pixabay Music, YouTube Audio Library..." style={{width:'100%',padding:'8px 12px',background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:8,color:'#f1f5f9',fontSize:13,boxSizing:'border-box'}}/></div>
                <div style={{marginBottom:12}}>
                  <label style={{fontSize:12,color:'#94a3b8',display:'block',marginBottom:4}}>File Audio * (MP3/M4A, max 30MB)</label>
                  <div onClick={()=>document.getElementById('admin-audio-input').click()} style={{border:'2px dashed '+(audioFile?'#a06bff':'rgba(255,255,255,0.12)'),borderRadius:8,padding:'16px',textAlign:'center',cursor:'pointer',background:'rgba(255,255,255,0.04)'}}>
                    {audioFile ? <span style={{color:'#a06bff',fontWeight:600}}>✅ {audioFile.name} ({(audioFile.size/1024/1024).toFixed(1)}MB)</span>
                      : <span style={{color:'#64748b'}}>🎵 Klik untuk pilih file MP3/M4A</span>}
                  </div>
                  <input id="admin-audio-input" type="file" accept=".mp3,.m4a,.aac,.wav,audio/*" style={{display:'none'}} onChange={e=>{const f=e.target.files[0];if(f&&f.size<=30*1024*1024)setAudioFile(f);else setAudioMsg('File terlalu besar, max 30MB');}}/>
                </div>
                <button onClick={uploadAudio} disabled={audioUploading||!audioFile||!audioUploadForm.title}
                  style={{padding:'10px 24px',background:(!audioFile||!audioUploadForm.title)?'rgba(255,255,255,0.12)':'#a06bff',color:(!audioFile||!audioUploadForm.title)?'#475569':'rgba(255,255,255,0.04)',border:'none',borderRadius:8,fontWeight:700,fontSize:13,cursor:(!audioFile||!audioUploadForm.title)?'not-allowed':'pointer'}}>
                  {audioUploading?'⏳ Mengupload...':'⬆️ Upload ke Library'}
                </button>
              </div>

              {/* Library List */}
              <div style={{background:'rgba(255,255,255,0.055)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:12,padding:20}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
                  <h2 style={{fontSize:15,fontWeight:600,color:'#f1f5f9'}}>📋 Daftar Lagu ({audioList.length})</h2>
                  <button onClick={fetchAudioLibrary} style={{padding:'6px 14px',background:'transparent',border:'1px solid rgba(255,255,255,0.12)',color:'#94a3b8',borderRadius:6,cursor:'pointer',fontSize:12}}>🔄 Refresh</button>
                </div>
                {audioLoading ? <div style={{textAlign:'center',color:'#64748b',padding:32}}>Loading...</div>
                : audioList.length === 0 ? <div style={{textAlign:'center',color:'#64748b',padding:32}}>Belum ada lagu di library</div>
                : audioList.map(audio => (
                  <div key={audio.id} style={{background:'rgba(255,255,255,0.04)',borderRadius:10,marginBottom:10,border:'1px solid rgba(255,255,255,0.12)',padding:'12px 14px'}}>
                    <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:8}}>
                      <div style={{width:32,height:32,borderRadius:8,background:'linear-gradient(135deg,#a06bff,#22d3ee)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:16,flexShrink:0}}>🎵</div>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{fontWeight:600,fontSize:13,color:'#f1f5f9',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{audio.title}</div>
                        <div style={{fontSize:11,color:'#64748b',marginTop:2}}>{[audio.artist,audio.genre,audio.mood,audio.duration_sec?Math.floor(audio.duration_sec/60)+':'+String(audio.duration_sec%60).padStart(2,'0'):null].filter(Boolean).join(' • ')}</div>
                        {audio.source&&<div style={{fontSize:10,color:'#475569'}}>Sumber: {audio.source}</div>}
                      </div>
                      <button onClick={()=>deleteAudio(audio.id,audio.title)} style={{padding:'5px 10px',background:'rgba(239,68,68,0.16)',border:'1px solid #ef4444',color:'#ef4444',borderRadius:6,cursor:'pointer',fontSize:11,flexShrink:0}}>🗑️</button>
                    </div>
                    <audio controls src={'https://api.eighteen-media.id/api/audio/stream/'+audio.id} style={{width:'100%',height:32}} />
                  </div>
                ))}
              </div>
            </div>
          )}
          {page==='ai' && (
            <div>
              <h1 style={{fontSize:20,fontWeight:700,color:'#f1f5f9',marginBottom:20}}>✨ AI Credits</h1>
              {aiStats && (
                <div className="admin-stats" style={{marginBottom:20}}>
                  {[
                    {l:'Total Generate',v:aiStats.total_generates,c:'#a06bff',i:'✨'},
                    {l:'Hari Ini',v:aiStats.today_generates,c:'#3b82f6',i:'📊'},
                    {l:'Kredit Terjual',v:aiStats.total_credits_sold,c:'#a06bff',i:'💰'},
                  ].map(s=>(
                    <div key={s.l} style={{background:'rgba(255,255,255,0.055)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:12,padding:16,textAlign:'center'}}>
                      <div style={{fontSize:20,marginBottom:4}}>{s.i}</div>
                      <div style={{fontSize:22,fontWeight:700,color:s.c}}>{s.v}</div>
                      <div style={{fontSize:11,color:'#64748b',marginTop:2}}>{s.l}</div>
                    </div>
                  ))}
                </div>
              )}
              <div style={{background:'rgba(255,255,255,0.055)',border:'1px solid #7b3fe4',borderRadius:12,padding:16,marginBottom:20,display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap',gap:8}}>
                <div>
                  <div style={{fontSize:14,fontWeight:600,color:'#f1f5f9'}}>🤖 Claude API (Anthropic)</div>
                  <div style={{fontSize:12,color:'#64748b',marginTop:2}}>Pantau saldo di console.anthropic.com</div>
                </div>
                <a href="https://console.anthropic.com" target="_blank" rel="noreferrer" style={{padding:'6px 14px',background:'#7b3fe4',color:'#fff',borderRadius:8,fontSize:12,textDecoration:'none'}}>Cek Saldo →</a>
              </div>
              <div style={{background:'rgba(255,255,255,0.055)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:12,padding:20}}>
                <h3 style={{fontSize:14,fontWeight:600,color:'#f1f5f9',marginBottom:16}}>Saldo per Client</h3>
                {aiClients.map(c=>(
                  <div key={c.id} style={{padding:'12px 0',borderBottom:'1px solid rgba(255,255,255,0.075)'}}>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',gap:8,flexWrap:'wrap'}}>
                      <div style={{flex:1}}>
                        <div style={{fontWeight:600,fontSize:13,color:'#f1f5f9'}}>{c.name}</div>
                        <div style={{fontSize:11,color:'#64748b'}}>{c.email} • Generate: {c.total_usage}x</div>
                      </div>
                      <div style={{display:'flex',alignItems:'center',gap:8,flexWrap:'wrap'}}>
                        <span style={{padding:'3px 12px',borderRadius:999,fontSize:13,fontWeight:700,background:c.balance>0?'#2d1a4a':'rgba(255,255,255,0.075)',color:c.balance>0?'#a06bff':'#64748b'}}>{c.balance} kredit</span>
                        {[10,30,100].map(amt=>(
                          <button key={amt} onClick={()=>topupCredits(c.id,amt)} style={{padding:'4px 10px',background:'linear-gradient(135deg,#7b3fe4,#a06bff)',border:'none',borderRadius:6,color:'#fff',fontSize:11,cursor:'pointer'}}>+{amt}</button>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {page==='gprojects' && (
            <div>
              <h1 style={{fontSize:20,fontWeight:700,color:'#f1f5f9',marginBottom:6}}>Google Projects</h1>
              <p style={{fontSize:13,color:'#64748b',marginBottom:20}}>Monitoring kuota YouTube API per Google Cloud project.</p>
              <AddGoogleProject api={API} onChanged={fetchGoogleProjects} showMsg={showMsg} />
              {googleProjects.length === 0 ? (
                <div style={{textAlign:'center',padding:40,color:'#64748b'}}>Belum ada project terdaftar.</div>
              ) : googleProjects.map(p => {
                const quotaPct = p.quota_limit > 0 ? Math.min(100, Math.round((p.quota_used / p.quota_limit) * 100)) : 0;
                const userPct = Math.min(100, Math.round((p.user_count / 100) * 100));
                const quotaColor = quotaPct >= 90 ? '#ef4444' : quotaPct >= 70 ? '#f59e0b' : '#10b981';
                const userColor = p.user_count >= 100 ? '#ef4444' : p.user_count >= 80 ? '#f59e0b' : '#10b981';
                return (
                  <div key={p.id} style={{background:'rgba(255,255,255,0.055)',border:'1px solid rgba(255,255,255,0.12)',borderRadius:12,padding:18,marginBottom:12}}>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:14,flexWrap:'wrap',gap:8}}>
                      <div style={{fontWeight:600,fontSize:14,color:'#f1f5f9'}}>{p.project_id}</div>
                      <span style={{fontSize:11,fontWeight:600,padding:'3px 10px',borderRadius:999,background:p.is_active?'rgba(16,185,129,0.16)':'rgba(239,68,68,0.16)',color:p.is_active?'#10b981':'#ef4444'}}>{p.is_active?'Aktif':'Nonaktif'}</span>
                    </div>
                    <div style={{marginBottom:12}}>
                      <div style={{display:'flex',justifyContent:'space-between',fontSize:12,color:'#94a3b8',marginBottom:5}}>
                        <span>Kuota Upload</span>
                        <span>{p.quota_used} / {p.quota_limit}</span>
                      </div>
                      <div style={{height:8,background:'rgba(255,255,255,0.075)',borderRadius:4,overflow:'hidden'}}>
                        <div style={{height:'100%',width:quotaPct+'%',background:quotaColor,borderRadius:4}} />
                      </div>
                    </div>
                    <div>
                      <div style={{display:'flex',justifyContent:'space-between',fontSize:12,color:'#94a3b8',marginBottom:5}}>
                        <span>OAuth User Cap</span>
                        <span>{p.user_count} / 100</span>
                      </div>
                      <div style={{height:8,background:'rgba(255,255,255,0.075)',borderRadius:4,overflow:'hidden'}}>
                        <div style={{height:'100%',width:userPct+'%',background:userColor,borderRadius:4}} />
                      </div>
                    </div>
                    <GoogleProjectActions api={API} project={p} onChanged={fetchGoogleProjects} showMsg={showMsg} />
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

function ClientList({ clients, onDetail }) {
  return (
    <div>
      {clients.map(c=>(
        <div key={c.id} onClick={()=>onDetail(c.id)} style={{padding:'12px 14px',background:'rgba(255,255,255,0.075)',borderRadius:10,marginBottom:8,cursor:'pointer',border:'1px solid rgba(255,255,255,0.12)'}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',gap:8}}>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontWeight:600,fontSize:14,color:'#f1f5f9'}}>{c.name}</div>
              <div style={{fontSize:11,color:'#64748b',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{c.email}</div>
              <div style={{fontSize:11,color:'#64748b'}}>{c.artist_name||'-'}</div>
            </div>
            <div style={{display:'flex',flexDirection:'column',alignItems:'flex-end',gap:4,flexShrink:0}}>
              {c.plan?<span style={{padding:'2px 8px',borderRadius:999,fontSize:10,background:'rgba(160,107,255,0.16)',color:'#a06bff',fontWeight:600}}>{c.plan.toUpperCase()}</span>
                :<span style={{fontSize:10,color:'#64748b'}}>FREE</span>}
              <span style={{padding:'2px 8px',borderRadius:999,fontSize:10,background:c.status==='active'?'rgba(16,185,129,0.16)':'rgba(239,68,68,0.16)',color:c.status==='active'?'#10b981':'#ef4444'}}>{c.status}</span>
              {c.pending_yt_emails>0&&<span style={{padding:'2px 8px',borderRadius:999,fontSize:10,background:'rgba(160,107,255,0.16)',color:'#a06bff'}}>🔔 {c.pending_yt_emails}</span>}
            </div>
          </div>
          <div style={{display:'flex',gap:12,marginTop:8,fontSize:11,color:'#64748b'}}>
            <span>📺 {c.channel_count||0} ch</span>
            <span>📋 {c.job_count||0} jobs</span>
            {c.expires_at&&<span style={{color:new Date(c.expires_at)<new Date()?'#ef4444':'#94a3b8'}}>⏰ {new Date(c.expires_at).toLocaleDateString('id-ID')}</span>}
          </div>
        </div>
      ))}
    </div>
  );
}

export default App;
